import { AgentProposalToolName } from "@rebuild/shared/models";

// Consecutive calls to the same tool share one label, which takes how many of them have succeeded.
type AgentToolLabel = (successCount: number) => string;

// Leaves the number out until the first call succeeds, rather than showing "0".
const counted =
  (verb: string, noun: string): AgentToolLabel =>
  (count) =>
    count === 0 ? `${verb} ${noun}s…` : `${verb} ${count} ${noun}${count === 1 ? "" : "s"}…`;

// Shown while the agent calls a tool. Proposal tools say "drafting": nothing changes until the user
// accepts the proposal.
export const AGENT_TOOL_LABELS: Record<string, AgentToolLabel> = {
  [AgentProposalToolName.propose_line_item_archive]: counted("Drafting", "line item archive"),
  [AgentProposalToolName.propose_line_item_formula_update]: counted("Drafting", "quantity update"),
  [AgentProposalToolName.propose_line_item_permutation_update]: counted("Drafting", "line item change"),
  [AgentProposalToolName.propose_room_create]: counted("Drafting", "new room"),
  [AgentProposalToolName.propose_room_rename]: counted("Drafting", "room rename"),
  [AgentProposalToolName.propose_room_archive]: counted("Drafting", "room archive"),
  [AgentProposalToolName.propose_line_item_create]: counted("Drafting", "new line item"),
  get_template_options: counted("Checking", "line item"),
  get_templates_by_query: counted("Searching", "line item"),
};

export const DEFAULT_AGENT_TOOL_LABEL: AgentToolLabel = () => "Working…";
